import RewardsImage from '../../images/RewardsImage.png';
function Rewards() {
    return (

        <div style={{ marginLeft: '20px', marginTop: '20px' }}>
            <img src={RewardsImage} style={{ width: '100%', height: '' }} alt="" />
        </div>
    );
}
export default Rewards;